<script>
import { required } from "vuelidate/lib/validators";
import VueDropify from "vue-dropify";
import draggable from "vuedraggable";
import Swal from "sweetalert2";
import Middleware from "@/helpers/middlewares";

import UserService from "@/helpers/APIService/user.service";
import { authComputed } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";

export default {
  data() {
    return {
      building: {
        name: "",
        short_name: "",
        edit: false,
        id: null,
        image: null,
      },
      submitted: false,
      isBtnLoading: false,
      isSaveAndAddNew: false,
      imagePreView: [],
      imageToSubmit: [],
      isImageUploading: false,
      editId: null,
    };
  },
  components: {
    VueDropify,
    draggable,
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "cancelSubmit"],
  computed: {
    ...authComputed,
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  validations: {
    building: {
      name: {
        required,
      },
      short_name: {
        required,
      },
    },
  },
  mounted() {
    this.setIfEdit();
  },
  methods: {
    setIfEdit() {
      if (this.currentProps.isEdit) {
        this.editId = this.currentProps.selectedBuilding.id;
        this.building.name = this.currentProps.selectedBuilding.name;
        this.building.short_name =
          this.currentProps.selectedBuilding.short_name;
        this.imagePreView = this.currentProps.selectedBuilding.building_image;
      }
    },
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {
          hotel: this.hotel.id,
        };
        data = { ...data, ...this.building };
        if (this.currentProps.isEdit == false) {
          UserService.createBuilding(data)
            .then(
              (building) => {
                let building_image = [];
                if (this.imageToSubmit.length !== 0) {
                  this.imageToSubmit.map((image, index) => {
                    let buildingImage = new FormData();
                    buildingImage.append("building", building.id);
                    buildingImage.append("image", image);
                    if (index == 0) {
                      buildingImage.append("is_thumbnail", true);
                    }
                    UserService.addPhotoToBuilding(building.id, buildingImage)
                      .then((response) => {
                        building_image.push(response);
                        this.$root.$emit("imageAddedInBuilding", response);

                        this.isBtnLoading = false;
                        this.submitted = false;
                      })
                      .catch((error) => {
                        errorHandler(error);
                      });
                  });
                } else {
                  this.isBtnLoading = false;
                  this.submitted = false;
                }
                if (this.isSaveAndAddNew) {
                  this.$emit("saveAndAddNew", { ...building, building_image });
                  this.building = {
                    name: "",
                    short_name: "",
                    edit: false,
                    id: null,
                  };
                } else {
                  this.$emit("submitted", { ...building, building_image });
                }
              },
              (error) => {
                this.isBtnLoading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        } else {
          UserService.editBuilding(data, this.currentProps.selectedBuilding.id)
            .then(
              (building) => {
                this.$emit("submitted", building);
                this.isBtnLoading = false;
                this.submitted = false;
              },
              (error) => {
                this.isBtnLoading = false;
                errorHandler(error);
              }
            )
            .catch((error) => {
              errorHandler(error);
            });
        }
      }
    },
    // Method is use for save and add new building continue
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is use for cancel to add new building
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    //Method is use for change image as thumbnail image
    changeThumbnailImageStatus(image) {
      const imageData = new FormData();
      imageData.append("is_thumbnail", image.is_thumbnail);
      UserService.updatePhotoToBuilding(
        image.building,
        image.id,
        imageData
      ).then(
        (response) => {
          this.$root.$emit("updateImageStatusInBuilding", response);
          this.imagePreView = this.imagePreView.map((image) => {
            if (image.id !== response.id) {
              image = { ...image, is_thumbnail: false };
            } else {
              image = { ...image, is_thumbnail: true };
            }
            return image;
          });
          Middleware.notification(
            "Thumbnail image successfully set !!",
            "success"
          );
        },
        (error) => {
          errorHandler(error);
        }
      );
    },
    // Method is use for delete image
    deleteImage(image, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deletePhotoToBuilding(image.building, image.id).then(
            () => {
              this.$root.$emit(
                "removeImageInBuilding",
                this.imagePreView[index]
              );
              this.imagePreView.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "warning");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // Method is use for maintained change image event
    changeBuildingImage(event) {
      const imgURL = event[0] == undefined ? null : event[0];
      if (imgURL !== null && this.currentProps.isEdit) {
        this.isImageUploading = true;
        let buildingImageData = new FormData();
        buildingImageData.append("building", this.editId);
        buildingImageData.append("image", imgURL);
        UserService.addPhotoToBuilding(this.editId, buildingImageData).then(
          (response) => {
            this.imagePreView.push(response);
          },
          (error) => {
            this.isImageUploading = false;
            errorHandler(error);
          }
        );
      } else {
        if (imgURL !== null) {
          this.imageToSubmit.push(imgURL);
          let image = window.URL.createObjectURL(event[0]);
          this.imagePreView.push({
            image,
            id: this.imageToSubmit.length,
            is_thumbnail: false,
            priority_order: this.imageToSubmit.length,
          });
          this.building.image = null;
          setTimeout(() => {
            document.querySelector(".has-icon").click();
          }, 500);
        }
      }
    },
    // Method is use for change building image
    onChoose: function (evt) {
      const imageData = new FormData();
      imageData.append("priority_order", evt.moved.newIndex + 1);
      UserService.updatePhotoToBuilding(
        evt.moved.element.building,
        evt.moved.element.id,
        imageData
      )
        .then(() => {
          Middleware.notification("Image position changed !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>{{ this.currentProps.isEdit ? "Update" : "Add New" }} Building</h4>
        <hr />

        <div class="row">
          <div class="col-md-6">
            <b-form-group class="mb-3" label="Name" label-for="room_type">
              <template slot="label">
                Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="room_type"
                type="text"
                autocomplete="off"
                placeholder="Ex : Building Name"
                v-model="building.name"
                :class="{
                  'is-invalid': submitted && $v.building.name.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.building.name.required"
                  >Building name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group
              class="mb-3"
              label="Short Code"
              label-for="short_code"
            >
              <template slot="label">
                Short Name <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="short_code"
                type="text"
                autocomplete="off"
                placeholder="Ex : Building Short Name"
                v-model="building.short_name"
                :class="{
                  'is-invalid': submitted && $v.building.short_name.$error,
                }"
              ></b-form-input>
              <div v-if="submitted" class="invalid-feedback">
                <span v-if="!$v.building.short_name.required"
                  >Building short name is required.</span
                >
              </div>
            </b-form-group>
          </div>
          <div class="col-md-12">
            <label for="Image">
              <span slot="label">Image</span>
            </label>
            <draggable
              class="row"
              v-model="imagePreView"
              v-bind="dragOptions"
              @change="onChoose"
              :disabled="!currentProps.isEdit"
            >
              <div
                class="col-md-3"
                v-for="(image, index) in imagePreView"
                :key="index"
              >
                <div class="d-flex align-items-start mb-3">
                  <div>
                    <img
                      class="rounded object-fit common-upload-img-size"
                      alt="room_type_image"
                      :src="
                        typeof image.image !== null || '' ? image.image : ''
                      "
                      :id="image.id"
                      data-holder-rendered="true"
                      :class="currentProps.isEdit ? 'cursor-move' : ''"
                    />
                  </div>
                  <div class="ms-2" v-if="currentProps.isEdit">
                    <div class="form-check">
                      <input
                        :disabled="
                          imagePreView.length == 1 && image.is_thumbnail
                        "
                        class="form-check-input"
                        type="checkbox"
                        :id="image.is_thumbnail"
                        v-model="image.is_thumbnail"
                        v-b-popover.hover="'Use as thumbnail image'"
                        @change="changeThumbnailImageStatus(image)"
                      />
                    </div>
                    <i
                      class="mdi mdi-trash-can fs-5 text-danger"
                      v-if="imagePreView.length !== 1 && !image.is_thumbnail"
                      slot="label"
                      @click="deleteImage(image, index)"
                    ></i>
                  </div>
                </div>
              </div>
              <div class="col-md-3" draggable="true" v-if="!isImageUploading">
                <div class="position-relative plus-icon">
                  <VueDropify
                    @upload="changeBuildingImage($event)"
                    :src="building.image"
                    accept="image/png, image/svg, image/jpg, image/jpeg"
                    message="Drop image or click here to select"
                    height="150px"
                    id="infoServices_images"
                    class="mb-3"
                  />
                  <i class="bx bx-plus fs-1"></i>
                </div>
              </div>
              <div class="col-md-3 placeholder-glow" v-else>
                <p
                  class="placeholder placeholder-lg common-upload-img-size"
                ></p>
              </div>
            </draggable>
          </div>
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              v-if="this.currentProps.isEdit === false"
              class="float-end ms-2"
              variant="outline-primary"
              type="submit"
              @click="saveAndAddNew"
              :class="{
                disabled: isSaveAndAddNew === true && isBtnLoading,
              }"
            >
              <i
                v-if="isSaveAndAddNew === true && isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Save & Add</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isSaveAndAddNew === false && isBtnLoading,
              }"
            >
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                v-if="isSaveAndAddNew === false && isBtnLoading"
              ></i>
              {{ this.currentProps.isEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
